"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisualModelServiceImpl = void 0;
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const ServiceImplBase_1 = require("./ServiceImplBase");
class VisualModelServiceImpl extends ServiceImplBase_1.ServiceImplBase {
    get serviceName() {
        return "visual-model-service" /* ServiceNames.VisualModel */;
    }
    getVisualSpecificationAsync(visualId) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'getVisualSpecificationAsync',
            [api_internal_contract_js_1.ParameterId.WorksheetName]: visualId.worksheet,
        };
        return this.execute(api_internal_contract_js_1.VerbId.GetVisualSpecification, parameters).then((response) => {
            const result = response.result;
            return result;
        });
    }
    addMarksCardFieldsAsync(visualId, marksCardIndex, encodingType, columns, startIndex) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'addMarksCardFieldsAsync',
            [api_internal_contract_js_1.ParameterId.WorksheetName]: visualId.worksheet,
            [api_internal_contract_js_1.ParameterId.MarksCardIndex]: marksCardIndex,
            [api_internal_contract_js_1.ParameterId.EncodingType]: encodingType,
            [api_internal_contract_js_1.ParameterId.Columns]: columns,
            [api_internal_contract_js_1.ParameterId.StartIndex]: startIndex,
        };
        return this.execute(api_internal_contract_js_1.VerbId.AddMarksCardFields, parameters).then(() => {
            return;
        });
    }
    moveMarksCardFieldAsync(visualId, marksCardIndex, fromIndex, toIndex, fieldCount = 1) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'addMarksCardFieldsAsync',
            [api_internal_contract_js_1.ParameterId.WorksheetName]: visualId.worksheet,
            [api_internal_contract_js_1.ParameterId.MarksCardIndex]: marksCardIndex,
            [api_internal_contract_js_1.ParameterId.FromIndex]: fromIndex,
            [api_internal_contract_js_1.ParameterId.ToIndex]: toIndex,
            [api_internal_contract_js_1.ParameterId.FieldCount]: fieldCount,
        };
        return this.execute(api_internal_contract_js_1.VerbId.MoveMarksCardField, parameters).then(() => {
            return;
        });
    }
    spliceMarksCardFieldsAsync(visualId, marksCardIndex, encodingType, startIndex, deleteCount, columns) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'spliceMarksCardFieldsAsync',
            [api_internal_contract_js_1.ParameterId.WorksheetName]: visualId.worksheet,
            [api_internal_contract_js_1.ParameterId.MarksCardIndex]: marksCardIndex,
            [api_internal_contract_js_1.ParameterId.EncodingType]: encodingType,
            [api_internal_contract_js_1.ParameterId.StartIndex]: startIndex,
            [api_internal_contract_js_1.ParameterId.DeleteCount]: deleteCount,
            [api_internal_contract_js_1.ParameterId.Columns]: columns,
        };
        return this.execute(api_internal_contract_js_1.VerbId.SpliceMarksCardFields, parameters).then(() => {
            return;
        });
    }
    editAliasesDialogAsync(fieldName) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'editAliasesDialogAsync',
            [api_internal_contract_js_1.ParameterId.FieldId]: fieldName,
        };
        return this.execute(api_internal_contract_js_1.VerbId.EditAliasesDialog, parameters).then(() => {
            return;
        });
    }
}
exports.VisualModelServiceImpl = VisualModelServiceImpl;
//# sourceMappingURL=VisualModelServiceImpl.js.map